/**
 * Route constants for the application
 */

export const ROUTES = {
  WORK_QUEUE: '/',
  DEV_API: '/dev',
} as const
